/**
 * Method to initialise a boolean property with true if this property is just defined on template
 *
 * Example with the property 'editMode' :
 * <app-document editMode ...></app-document>
 * is the same than :
 * <app-document [editMode]="true" ... ></app-document>
 *
 */
export function CoerceBoolean() {
    return function(target: any, key: string): void {
        const getter = function() {
            // using Typescript reflection
            // @ts-ignore
            return this['__' + key];
        };

        const setter = function(next: any) {
            // using Typescript reflection
            // @ts-ignore
            this['__' + key] = next !== null && next !== undefined && `${next}` !== 'false';
        };

        Object.defineProperty(target, key, {
            get: getter,
            set: setter,
            enumerable: true,
            configurable: true
        });
    };
}